//获取两位小数规范
function getDecimal(num) {
  let decimal = num.toString().match(/^\d*(\.?\d{0,2})/g)
    ? num === "00"
      ? "0"
      : num.toString().match(/^\d*(\.?\d{0,2})/g)[0]
    : "";
  return decimal;
}

/* 限制金额为2位小数（包含负数） */
function inputAllTwoDecimal(val) {
  let price = val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)
    ? val === "00"
      ? "0"
      : val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)[0]
    : "";
  return price;
}

//获取整数规范
function getInteger(num) {
  let integer = num.toString().match(/^[1-9]\d*/)
    ? num.toString().match(/^[1-9]\d*/)[0]
    : num === "0"
    ? "0"
    : "";
  return integer;
}

function formatTimeToDate(time) {
  let date = new Date(time);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  let detailDate = date.getDate();
  detailDate = detailDate > 9 ? detailDate : "0" + detailDate;
  return `${year}-${month}-${detailDate}`;
}

function formaTimeToSecond(time) {
  let date = new Date(time);
  let hour = date.getHours();
  hour = hour > 9 ? hour : "0" + hour;
  let minute = date.getMinutes();
  minute = minute > 9 ? minute : "0" + minute;
  let second = date.getSeconds();
  second = second > 9 ? second : "0" + second;
  return `${hour}:${minute}:${second}`;
}

function formaTimeToMinute(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  return `${year}-${month}-${detailDate}  ${hour}:${minute}`
}

function formaTimeToAllSecond(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  let second = date.getSeconds();
  second = second > 9 ? second : "0" + second;
  return `${year}-${month}-${detailDate}  ${hour}:${minute}:${second}`
}

/* 时间戳转化为年月 */
function formatTimeToYearAndMonth() {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  return `${year}-${month}`
}

function handleGetRequestParams(params) {
  let url = ''
  for (let key in params) {
    let value = (params[key] !== undefined && params[key] !== null) ? params[key] : '';
    url += `&${key}=${encodeURIComponent(value)}`
  }
  return url.substring(1)
}

/* 把url转为[blob]文件格式(包括图片,pdf,word,excel)下载，
第一个参数是文件名称，第二个参数是文件的路径 */
function downLoadFile(fileName, data) {
  if (!data) {
    return
  }
  fetch(data).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
    let url = window.URL.createObjectURL(blob)
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  })
}

export { getDecimal, inputAllTwoDecimal, getInteger, formatTimeToDate, formaTimeToMinute, formatTimeToYearAndMonth, formaTimeToSecond, formaTimeToAllSecond, handleGetRequestParams, downLoadFile };
